import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	fetchConnectorListFail,
	fetchConnectorListSuccess,
	initConnectorList,
	refreshConnectorList,
	bulkDeleteConnectors,
	bulkDeleteConnectorsFail,
	bulkDeleteConnectorsSuccess,
	deleteConnector,
	deleteConnectorFail,
	deleteConnectorSuccess,
} from './connector.actions';
import { ConnectorOriginalSliceState } from './connector.state';

export const connectorOriginalReducer =
	createReducer<ConnectorOriginalSliceState>(
		new ConnectorOriginalSliceState(),
		on(goToProjects, setProject, (state) => state.clear()),
		on(initConnectorList, refreshConnectorList, (state) =>
			state.setLoading(true)
		),
		on(fetchConnectorListFail, (state) => state.setLoading(false)),
		on(fetchConnectorListSuccess, (state, action) =>
			state.setLoading(false).setConnectorList(action.connectorList)
		),
		on(deleteConnector, bulkDeleteConnectors, (state) =>
			state.setActionInProgress(true)
		),
		on(
			deleteConnectorSuccess,
			deleteConnectorFail,
			bulkDeleteConnectorsSuccess,
			bulkDeleteConnectorsFail,
			(state) => state.setActionInProgress(false)
		)
	);
